import Loader from "./Loader";

export const containerStyle = {
    display: "flex",
    width: "100vw",
    height: "100vh",
    alignItems: "center",
    justifyContent: "center"
};

const LoaderLite = (
    <Loader/>
)


export default LoaderLite;